import React from 'react';
import styled, { css } from 'styled-components';
import Icons from './index';

const StyledSvg = styled.svg.attrs({
  version: '1.1',
  xmlns: 'http://www.w3.org/2000/svg',
  xmlnsXlink: 'http://www.w3.org/1999/xlink'
})``;

const StyledIcon = styled(StyledSvg)`
  margin: ${props => (props.margin ? props.margin : '0 8px')};
  float: ${props => (props.float ? props.float : 'left')};
  ${props =>
    props.size === 100 &&
    css`
      width: 16px;
      height: 16px;
    `}
  ${props =>
    props.size === 200 &&
    css`
      width: 24px;
      height: 24px;
    `}
  ${props =>
    props.size === 300 &&
    css`
      width: 32px;
      height: 32px;
    `}
  ${props =>
    props.size === 500 &&
    css`
      width: 50px;
      height: 50px;
    `}
  path {
    ${props =>
      props.svgPathFill &&
      css`
        fill: ${p => p.svgPathFill};
      `}
  }
`;

const sizes = {
  100: '16px',
  200: '24px',
  250: '28px',
  300: '32px',
  500: '50px'
};

export const Icon = ({ name, size = 100, margin, float, svgPathFill }) => {
  const Ico = Icons[name];
  if (Ico === undefined) {
    return '';
  }
  return (
    <StyledIcon width={sizes[size]} height={sizes[size]} margin={margin} float={float} svgPathFill={svgPathFill}>
      <Ico width={sizes[size]} height={sizes[size]} />
    </StyledIcon>
  );
};
